import React from 'react';
import CustomDateRange from '../../../../../dashboard/components/customDateRange';
import reportPdfIcon from '../../../../../../assets/image/report-pdf-icon.svg';
import xlsIcon from '../../../../../../assets/image/xls-icon.svg';
import csvIcon from '../../../../../../assets/image/csv-icon.svg';
import arrowBackIcon from '../../../../../../assets/image/subscription/arrow-back-box-icon.svg';
import arrowForwardIcon from '../../../../../../assets/image/subscription/arrow-forward-box-icon.svg';

export default function ManageBillingTable({ tableColumns, data, params, setParams }) {
	return (
		<div className="mt-4">
			<div
				className="d-flex justify-content-between align-items-center rounded-2 py-3 px-4"
				style={{ backgroundColor: 'rgba(249, 249, 251, 1)' }}
			>
				<div className="fs-4 fw-bold text-dark">Past Transactions</div>
				<div className="d-flex align-items-center gap-4 px-3">
					<div>
						<CustomDateRange
							handleDataByDateRange={() => {}}
							style={{ border: 'none' }}
							range={{ start_date: params.start_date, end_date: params.end_date }}
							setRange={setParams}
						/>
					</div>
					<div className="fs-4 fw-bold text-dark">{`1 - 4 of 4`}</div>
					<img
						width={30}
						height={30}
						className="cursor-pointer"
						src={arrowBackIcon}
						alt="Icon"
					/>
					<img
						width={30}
						height={30}
						className="cursor-pointer"
						src={arrowForwardIcon}
						alt="Icon"
					/>
				</div>
			</div>
			<div className="report-table-container">
				<table
					className="report-table"
					style={{ maxHeight: 'calc(100vh - 500px)' }}
				>
					<thead>
						<tr>
							{tableColumns.map((m, i) => (
								<th
									className="cursor-pointer"
									key={`${i}`}
									onClick={() => {}}
								>
									<div
										className={`d-flex  align-items-center gap-4 ${m.align === 'right' ? 'justify-content-end' : m.align === 'center' ? 'justify-content-center' : 'justify-content-start'}`}
									>
										{m.label}
									</div>
								</th>
							))}
						</tr>
					</thead>
					<tbody>
						{data.map((p, i) => (
							<tr key={i}>
								{tableColumns.map((m, idx) => (
									<td key={`${i}-${idx}`}>
										{p[m.key] !== 'pdf' ? (
											<div
												className={`d-flex  align-items-center gap-4 ${m.align === 'right' ? 'justify-content-end' : m.align === 'center' ? 'justify-content-center' : 'justify-content-start'}`}
											>
												{p[m.key]}
											</div>
										) : (
											<div className="d-flex gap-3 align-items-center justify-content-center">
												<img
													src={
														p[m.key] === 'pdf'
															? reportPdfIcon
															: p[m.key] === 'csv'
																? csvIcon
																: xlsIcon
													}
													alt="icon"
												/>
												<div className="fs-4 fw-light">{p[m.key].toUpperCase()}</div>
											</div>
										)}
									</td>
								))}
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
}
